/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ChangeEvent, useEffect, useRef, useState } from 'react'

import 'react-circular-progressbar/dist/styles.css'
import { toast } from 'react-toastify'
import { useQuery } from 'react-query'
import { CircularProgressbar } from 'react-circular-progressbar'

import UIButton from '../../components/UI/UIButton'
import UiSelect from '../../components/UI/UISelect'
import UITextInput from '../../components/UI/UITextInput'
import UIDatePickerv from '../../components/UI/UIDatePickerv'
import UIStaightlineProressBar from '../../components/UI/UIStaightlineProressBar'
import { Icon } from '../../components/Icon'
import { getFirstLetter } from '../policy/utils'
import { fileUpload } from '../../api/apiService'
import { getProfile, updateProfile } from '../../api/admin/myscrApis'
import { Accordion, AccordionItem } from '../candidates/components/Accordion'
import {
  calculateNonNullPercentage,
  calculateCircularPercentage,
} from '../../utils/utils'
import {
  profileData,
  UploadResponse,
  ProfileDataResponse,
} from '../../utils/types'
import Modal from '../../components/UI/UIModal'

const nationalities = [
  'Afghan',
  'Albanian',
  'Algerian',
  'American',
  'Andorran',
  'Angolan',
  'Anguillan',
  'Citizen of Antigua and Barbuda',
  'Argentine',
  'Armenian',
  'Australian',
  'Austrian',
  'Azerbaijani',
  'Bahamian',
  'Bahraini',
  'Bangladeshi',
  'Barbadian',
  'Belarusian',
  'Belgian',
  'Belizean',
  'Beninese',
  'Bermudian',
  'Bhutanese',
  'Bolivian',
  'Citizen of Bosnia and Herzegovina',
  'Botswanan',
  'Brazilian',
  'British',
  'British Virgin Islander',
  'Bruneian',
  'Bulgarian',
  'Burkinan',
  'Burmese',
  'Cambodian',
  'Cameroonian',
  'Canadian',
  'Cape Verdean',
  'Cayman Islander',
  'Central African',
  'Chadian',
  'Chilean',
  'Chinese',
  'Colombian',
  'Comoran',
  'Congolese (Congo)',
  'Congolese (DRC)',
  'Cook Islander',
  'Costa Rican',
  'Croatian',
  'Cuban',
  'Cymraes',
  'Cymro',
  'Cypriot',
  'Czech',
  'Danish',
  'Djiboutian',
  'Dominican',
  'Citizen of the Dominican Republic',
  'Dutch',
  'East Timorese',
  'Ecuadorean',
  'Egyptian',
  'Emirati',
  'English',
  'Equatorial Guinean',
  'Eritrean',
  'Estonian',
  'Ethiopian',
  'Faroese',
  'Fijian',
  'Filipino',
  'Finnish',
  'French',
  'Gabonese',
  'Gambian',
  'Georgian',
  'German',
  'Ghanaian',
  'Gibraltarian',
  'Greek',
  'Greenlandic',
  'Grenadian',
  'Guamanian',
  'Guatemalan',
  'Citizen of Guinea-Bissau',
  'Guinean',
  'Guyanese',
  'Haitian',
  'Honduran',
  'Hong Konger',
  'Hungarian',
  'Icelandic',
  'Indian',
  'Indonesian',
  'Iranian',
  'Iraqi',
  'Irish',
  'Israeli',
  'Italian',
  'Ivorian',
  'Jamaican',
  'Japanese',
  'Jordanian',
  'Kazakh',
  'Kenyan',
  'Kittitian',
  'Citizen of Kiribati',
  'Kosovan',
  'Kuwaiti',
  'Kyrgyz',
  'Lao',
  'Latvian',
  'Lebanese',
  'Liberian',
  'Libyan',
  'Liechtenstein citizen',
  'Lithuanian',
  'Luxembourger',
  'Macanese',
  'Macedonian',
  'Malagasy',
  'Malawian',
  'Malaysian',
  'Maldivian',
  'Malian',
  'Maltese',
  'Marshallese',
  'Martiniquais',
  'Mauritanian',
  'Mauritian',
  'Mexican',
  'Micronesian',
  'Moldovan',
  'Monegasque',
  'Mongolian',
  'Montenegrin',
  'Montserratian',
  'Moroccan',
  'Mosotho',
  'Mozambican',
  'Namibian',
  'Nauruan',
  'Nepalese',
  'New Zealander',
  'Nicaraguan',
  'Nigerian',
  'Nigerien',
  'Niuean',
  'North Korean',
  'Northern Irish',
  'Norwegian',
  'Omani',
  'Pakistani',
  'Palauan',
  'Palestinian',
  'Panamanian',
  'Papua New Guinean',
  'Paraguayan',
  'Peruvian',
  'Pitcairn Islander',
  'Polish',
  'Portuguese',
  'Prydeinig',
  'Puerto Rican',
  'Qatari',
  'Romanian',
  'Russian',
  'Rwandan',
  'Salvadorean',
  'Sammarinese',
  'Samoan',
  'Sao Tomean',
  'Saudi Arabian',
  'Scottish',
  'Senegalese',
  'Serbian',
  'Citizen of Seychelles',
  'Sierra Leonean',
  'Singaporean',
  'Slovak',
  'Slovenian',
  'Solomon Islander',
  'Somali',
  'South African',
  'South Korean',
  'South Sudanese',
  'Spanish',
  'Sri Lankan',
  'St Helenian',
  'St Lucian',
  'Stateless',
  'Sudanese',
  'Surinamese',
  'Swazi',
  'Swedish',
  'Swiss',
  'Syrian',
  'Taiwanese',
  'Tajik',
  'Tanzanian',
  'Thai',
  'Togolese',
  'Tongan',
  'Trinidadian',
  'Tristanian',
  'Tunisian',
  'Turkish',
  'Turkmen',
  'Turks and Caicos Islander',
  'Tuvaluan',
  'Ugandan',
  'Ukrainian',
  'Uruguayan',
  'Uzbek',
  'Vatican citizen',
  'Citizen of Vanuatu',
  'Venezuelan',
  'Vietnamese',
  'Vincentian',
  'Wallisian',
  'Welsh',
  'Yemeni',
  'Zambian',
  'Zimbabwean',
]
const ethnicGroups = [
  'Indian',
  'Pakistani',
  'Bangladeshi',
  'Chinese',
  'Any other Asian background',
  'Caribbean',
  'African',
  'Any other Black, Black British, or Caribbean background',
  'White and Black Caribbean',
  'White and Black African',
  'White and Asian',
  'Any other Mixed or multiple ethnic background',
  'English, Welsh, Scottish, Northern Irish or British',
  'Irish',
  'Gypsy or Irish Traveller',
  'Roma',
  'Any other White background',
  'Arab',
  'Any other ethnic group',
  'Not Provided / Prefer Not To Say',
]

const profileDataEmptyData: profileData = {
  basicInformation: {
    title: '',
    firstName: '',
    lastName: '',
    profileImage: '',
    dateOfBirth: '',
    gender: '',
    ethnicity: '',
    disability: '',
    nationality: '',
  },
  address: {
    addressLineOne: '',
    addressLineTwo: '',
    town: '',
    country: '',
    postCode: '',
  },
  contactInformation: {
    businessContactNumber: '',
    extensionNumber: '',
    personalContactNumber: '',
    businessEmail: '',
    personalEmail: '',
  },
  emergencyContact: {
    firstName: '',
    lastName: '',
    contactNumber: '',
    relationship: '',
    addressLineOne: '',
    addressLineTwo: '',
    town: '',
    country: '',
    postCode: '',
  },
}

const ProfileInformation = () => {
  const divRef = useRef<HTMLDivElement>(null)
  const [alertActive, setAlertActive] = useState(false)
  const [isOpenAlert, setIsOpenAlert] = useState(false)
  const [userData, setUserData] = useState<profileData>()
  const [isUpdateLoading, setIsUpdateLoading] = useState<boolean>(false)

  const getProfileData = async (): Promise<profileData> => {
    const response = (await getProfile()) as ProfileDataResponse
    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }

  const { data, isLoading, isError, refetch } = useQuery(
    'userProfile',
    getProfileData
  )

  useEffect(() => {
    if (data) {
      if (Object.keys(data).length == 0) {
        setUserData(profileDataEmptyData)
      } else {
        setUserData(data)
      }
    }
    // setTitle(data?.basicInformation?.title)
    // setFirstName(data?.basicInformation?.firstName)
    // setLastName(data?.basicInformation?.lastName)
  }, [data])

  const handleChange = (
    category: keyof profileData,
    fieldName: string,
    value: string
  ) => {
    setAlertActive(true)
    setUserData((prevValues: profileData | undefined) => {
      if (!prevValues) return prevValues // Return undefined if prevValues is undefined

      return {
        ...prevValues,
        [category]: {
          ...(prevValues[category] as (typeof prevValues)[keyof profileData]),
          [fieldName]: value,
        },
      }
    })
  }

  const handleBasicInformationChange = (fieldName: string, value: string) => {
    handleChange('basicInformation', fieldName, value)
  }
  const handleContactInfoChange = (fieldName: string, value: string) => {
    handleChange('contactInformation', fieldName, value)
  }
  const handleAddressInfoChange = (fieldName: string, value: string) => {
    handleChange('address', fieldName, value)
  }
  const handleEmergencyContactInfoChange = (
    fieldName: string,
    value: string
  ) => {
    handleChange('emergencyContact', fieldName, value)
  }

  const updateProfileData = async (values: profileData): Promise<void> => {
    setIsUpdateLoading(true)
    try {
      const response = (await updateProfile(values)) as {
        status?: string
        data: profileData
      }
      if (response?.status == 'successful') {
        refetch()
        toast.success('Profile Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('Network Error.', { position: 'top-right' })
    } finally {
      setIsUpdateLoading(false)
    }
  }

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_display_pictures',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleBasicInformationChange('profileImage', response?.url)
      } catch (error) {
        handleBasicInformationChange('profileImage', '')
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    }
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (
      divRef.current &&
      !divRef.current.contains(event.target as Node) &&
      alertActive
    ) {
      setIsOpenAlert(true)
    } else if (isOpenAlert == false) {
      setAlertActive(false)
    }
  }

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [alertActive])

  return (
    <div ref={divRef}>
      <div className="flex my-8 gap-2">
        {/* First column */}
        <div
          style={{
            // height: 'calc(100vh - 100px)',
            overflow: 'auto',
            // scrollbarWidth: 'none',
          }}
          className="flex flex-col w-8/12 gap-4"
        >
          <Accordion defaultActiveIndex={0}>
            <AccordionItem
              onClick={() => console.log('Accordion')}
              title={'Basic Information'}
              isActive={false}
            >
              <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                {userData?.basicInformation?.profileImageUrl != '' ? (
                  <div className="flex flex-row items-center gap-3">
                    <div className="flex items-center justify-center rounded-full text-white w-16 h-16">
                      <img
                        src={userData?.basicInformation?.profileImageUrl}
                        width={64}
                        height={64}
                        alt=""
                        className="rounded-full bg-transparent border-none w-16 h-16"
                      />
                    </div>
                    <div className="flex gap-3">
                      <label
                        htmlFor="fileInput"
                        // className={`text-sm font-normal text-text1 flex-1 cursor-pointer`}
                      >
                        <input
                          id="fileInput"
                          type="file"
                          onChange={handleFileChange}
                          style={{ display: 'none' }}
                          accept=".jpg, .jpeg, .png"
                        />

                        <div
                          onClick={() => {
                            console.log('profile upload')
                          }}
                          className="flex items-center justify-center rounded-[72px] bg-gray2 py-2 px-4 gap-2 cursor-pointer"
                        >
                          <Icon
                            name={'IconRefresh'}
                            strokeWidth={1}
                            stroke={'#02698C'}
                            width={16}
                            height={16}
                          />
                          <p className="text-xs font-medium text-text1 leading-5">
                            Change Profile Picture
                          </p>
                        </div>
                      </label>
                      <div
                        onClick={() => {
                          handleBasicInformationChange('profileImage', '')
                        }}
                        className="flex items-center justify-center rounded-[72px] border border-textError bg-transparent py-2 px-4 gap-2 cursor-pointer"
                      >
                        <Icon
                          name={'IconTrash'}
                          strokeWidth={1}
                          stroke={'#FF6666'}
                          width={16}
                          height={16}
                        />
                        <p className="text-xs font-medium text-textError leading-5">
                          Delete
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-row items-center gap-3">
                    <div className="flex items-center justify-center rounded-full bg-bluishGreen text-white w-16 h-16">
                      <p className="text-lg font-bold text-text8">
                        {userData?.basicInformation?.firstName
                          ? `${getFirstLetter(
                              userData?.basicInformation?.firstName
                            )}${getFirstLetter(userData?.basicInformation?.lastName)}`
                          : 'SCR'}
                      </p>
                    </div>
                    <label
                      htmlFor="fileInput"
                      // className={`text-sm font-normal text-text1 flex-1 cursor-pointer`}
                    >
                      <input
                        id="fileInput"
                        type="file"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        accept=".jpg, .jpeg, .png"
                      />
                      <div
                        onClick={() => {
                          console.log('profile upload')
                        }}
                        className="flex items-center justify-center rounded-[72px] bg-gray2 py-2 px-4 gap-2 cursor-pointer"
                      >
                        <Icon
                          name={'IconPlus'}
                          strokeWidth={1}
                          stroke={'#02698C'}
                          width={16}
                          height={16}
                        />
                        <p className="text-xs font-medium text-text1 leading-5">
                          Add Profile Picture
                        </p>
                      </div>
                    </label>
                  </div>
                )}
                <div className="flex w-full gap-4">
                  <div className="w-6/12 ">
                    <UiSelect
                      onChange={(e: string) => {
                        handleBasicInformationChange('title', e)
                      }}
                      value={userData?.basicInformation?.title}
                      options={[
                        { value: 'Mr.', label: 'Mr.' },
                        { value: 'Mrs.', label: 'Mrs.' },
                        { value: 'Ms.', label: 'Ms.' },
                        { value: 'Miss.', label: 'Miss.' },
                      ]}
                      title={'Title'}
                    />
                  </div>
                  <div className="w-6/12  ">
                    <UiSelect
                      onChange={(e: string) => {
                        handleBasicInformationChange('nationality', e)
                      }}
                      value={userData?.basicInformation?.nationality}
                      options={nationalities?.map((i) => ({
                        value: i,
                        label: i,
                      }))}
                      title={'Nationality'}
                    />
                    {/* ethnicGroups */}
                  </div>
                </div>
                <div className="flex w-full gap-4">
                  <div className="w-6/12  ">
                    <UITextInput
                      onChange={(e) => {
                        handleBasicInformationChange(
                          'firstName',
                          e.target.value
                        )
                      }}
                      value={userData?.basicInformation?.firstName}
                      placeholder={'First Name'}
                      label={'First Name'}
                      iconName={''}
                    />
                  </div>
                  <div className="w-6/12">
                    <UITextInput
                      onChange={(e) => {
                        handleBasicInformationChange('lastName', e.target.value)
                      }}
                      value={userData?.basicInformation?.lastName}
                      placeholder={'Last Name'}
                      label={'Last Name'}
                      iconName={''}
                    />
                  </div>
                </div>
                <div className="flex w-full gap-4">
                  <div className="w-6/12">
                    <UIDatePickerv
                      placeholderText={'Not Specified'}
                      title={'Date of Birth'}
                      onChange={(e) => {
                        handleBasicInformationChange(
                          'dateOfBirth',
                          e.target.value
                        )
                      }}
                      value={userData?.basicInformation?.dateOfBirth}
                    />
                  </div>
                  <div className="w-6/12">
                    <UiSelect
                      onChange={(e: string) => {
                        handleBasicInformationChange('gender', e)
                      }}
                      value={userData?.basicInformation?.gender}
                      options={[
                        { value: 'Male', label: 'Male' },
                        { value: 'Female', label: 'Female' },
                        {
                          value: 'Identifies in another way',
                          label: 'Identifies in another way',
                        },
                        {
                          value: 'Perfer not to say',
                          label: 'Perfer not to say',
                        },
                      ]}
                      title={'Gender'}
                    />
                  </div>
                </div>
                <div className="flex w-full gap-4">
                  <div className="w-6/12  ">
                    <UiSelect
                      onChange={(e: string) => {
                        handleBasicInformationChange('ethnicity', e)
                      }}
                      value={userData?.basicInformation?.ethnicity}
                      options={ethnicGroups?.map((i) => ({
                        value: i,
                        label: i,
                      }))}
                      title={'Ethnicity'}
                    />
                  </div>
                  <div className="w-6/12">
                    <UiSelect
                      onChange={(e: string) => {
                        handleBasicInformationChange('disability', e)
                      }}
                      value={userData?.basicInformation?.disability}
                      options={[
                        { value: 'Yes', label: 'Yes' },
                        { value: 'No', label: 'No' },
                        {
                          value: 'Prefer not to say',
                          label: 'Prefer not to say',
                        },
                      ]}
                      title={'Disability'}
                    />
                  </div>
                </div>

                {/* <div className="w-[48%]">
                    <UiSelect options={[]} title={'Disability'} />
                  </div> */}
              </div>
            </AccordionItem>
          </Accordion>
          <Accordion defaultActiveIndex={0}>
            <AccordionItem
              onClick={() => console.log('Accordion')}
              title={'Contact Information'}
              isActive={false}
            >
              <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                <div className="flex w-full gap-4">
                  <div className="w-6/12  ">
                    <UITextInput
                      placeholder="Business Contact Number"
                      label={'Business Contact Number'}
                      iconName={''}
                      onChange={(e) => {
                        handleContactInfoChange(
                          'businessContactNumber',
                          e.target.value
                        )
                      }}
                      value={
                        userData?.contactInformation?.businessContactNumber
                      }
                    />
                  </div>
                  <div className="w-6/12">
                    <UITextInput
                      placeholder="Extension Number"
                      label={'Extension Number'}
                      iconName={''}
                      onChange={(e) => {
                        handleContactInfoChange(
                          'extensionNumber',
                          e.target.value
                        )
                      }}
                      value={userData?.contactInformation?.extensionNumber}
                    />
                  </div>
                </div>
                <div className="w-[48%]">
                  <UITextInput
                    placeholder="Personal Contact Number"
                    label={'Personal Contact Number'}
                    iconName={''}
                    onChange={(e) => {
                      handleContactInfoChange(
                        'personalContactNumber',
                        e.target.value
                      )
                    }}
                    value={userData?.contactInformation?.personalContactNumber}
                  />
                </div>
                <div className="flex w-full gap-4">
                  <div className="w-6/12  ">
                    <UITextInput
                      placeholder={'Business Email Address'}
                      label={'Business Email Address'}
                      iconName={''}
                      onChange={(e) => {
                        handleContactInfoChange('businessEmail', e.target.value)
                      }}
                      value={userData?.contactInformation?.businessEmail}
                    />
                  </div>
                  <div className="w-6/12">
                    <UITextInput
                      placeholder={'Personal Email Address'}
                      label={'Personal Email Address'}
                      iconName={''}
                      onChange={(e) => {
                        handleContactInfoChange('personalEmail', e.target.value)
                      }}
                      value={userData?.contactInformation?.personalEmail}
                    />
                  </div>
                </div>
              </div>
            </AccordionItem>
          </Accordion>
          <Accordion defaultActiveIndex={0}>
            <AccordionItem
              onClick={() => console.log('Accordion')}
              title={'Address'}
              isActive={false}
            >
              <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                <div className="flex w-full gap-4">
                  <div className="w-6/12">
                    <UITextInput
                      placeholder={'Address Line 1'}
                      label={'Address Line 1'}
                      iconName={''}
                      onChange={(e) => {
                        handleAddressInfoChange(
                          'addressLineOne',
                          e.target.value
                        )
                      }}
                      value={userData?.address?.addressLineOne}
                    />
                  </div>
                  <div className="w-6/12">
                    <UITextInput
                      label={'Address Line 2'}
                      placeholder="(Optional)"
                      iconName={''}
                      onChange={(e) => {
                        handleAddressInfoChange(
                          'addressLineTwo',
                          e.target.value
                        )
                      }}
                      value={userData?.address?.addressLineTwo}
                    />
                  </div>
                </div>
                <div className="flex w-full gap-4">
                  <div className="w-6/12">
                    <UITextInput
                      placeholder={'Town'}
                      label={'Town'}
                      iconName={''}
                      onChange={(e) => {
                        handleAddressInfoChange('town', e.target.value)
                      }}
                      value={userData?.address?.town}
                    />
                  </div>
                  <div className="w-6/12">
                    <UITextInput
                      label={'Country'}
                      placeholder={'Country'}
                      iconName={''}
                      onChange={(e) => {
                        handleAddressInfoChange('country', e.target.value)
                      }}
                      value={userData?.address?.country}
                    />
                  </div>
                </div>
                <div className="w-[48%]">
                  <UITextInput
                    label={'Postcode'}
                    placeholder={'Postcode'}
                    iconName={''}
                    onChange={(e) => {
                      handleAddressInfoChange('postCode', e.target.value)
                    }}
                    value={userData?.address?.postCode}
                  />
                </div>
              </div>
            </AccordionItem>
          </Accordion>
          <Accordion defaultActiveIndex={0}>
            <AccordionItem
              onClick={() => console.log('Accordion')}
              title={'Emergency Contact'}
              isActive={false}
            >
              <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                <div className="flex w-full gap-4">
                  <div className="w-6/12">
                    <UITextInput
                      placeholder={'First Name'}
                      label={'First Name'}
                      iconName={''}
                      onChange={(e) => {
                        handleEmergencyContactInfoChange(
                          'firstName',
                          e.target.value
                        )
                      }}
                      value={userData?.emergencyContact?.firstName}
                    />
                  </div>
                  <div className="w-6/12">
                    <UITextInput
                      placeholder={'Last Name'}
                      label={'Last Name'}
                      iconName={''}
                      onChange={(e) => {
                        handleEmergencyContactInfoChange(
                          'lastName',
                          e.target.value
                        )
                      }}
                      value={userData?.emergencyContact?.lastName}
                    />
                  </div>
                </div>
                <div className="flex w-full gap-4">
                  <div className="w-6/12">
                    <UITextInput
                      placeholder={'Contact Number'}
                      label={'Contact Number'}
                      iconName={''}
                      onChange={(e) => {
                        handleEmergencyContactInfoChange(
                          'contactNumber',
                          e.target.value
                        )
                      }}
                      value={userData?.emergencyContact?.contactNumber}
                    />
                  </div>
                  <div className="w-6/12">
                    <UITextInput
                      placeholder={'Relationship'}
                      label={'Relationship'}
                      iconName={''}
                      onChange={(e) => {
                        handleEmergencyContactInfoChange(
                          'relationship',
                          e.target.value
                        )
                      }}
                      value={userData?.emergencyContact?.relationship}
                    />
                  </div>
                </div>
                <div className="flex w-full gap-4">
                  <div className="w-6/12">
                    <UITextInput
                      placeholder={'Address Line 1'}
                      label={'Address Line 1'}
                      iconName={''}
                      onChange={(e) => {
                        handleEmergencyContactInfoChange(
                          'addressLineOne',
                          e.target.value
                        )
                      }}
                      value={userData?.emergencyContact?.addressLineOne}
                    />
                  </div>
                  <div className="w-6/12">
                    <UITextInput
                      label={'Address Line 2'}
                      placeholder="(Optional)"
                      iconName={''}
                      onChange={(e) => {
                        handleEmergencyContactInfoChange(
                          'addressLineTwo',
                          e.target.value
                        )
                      }}
                      value={userData?.emergencyContact?.addressLineTwo}
                    />
                  </div>
                </div>
                <div className="flex w-full gap-4">
                  <div className="w-6/12">
                    <UITextInput
                      placeholder={'Town'}
                      label={'Town'}
                      iconName={''}
                      onChange={(e) => {
                        handleEmergencyContactInfoChange('town', e.target.value)
                      }}
                      value={userData?.emergencyContact?.town}
                    />
                  </div>
                  <div className="w-6/12">
                    <UITextInput
                      placeholder={'Country'}
                      label={'Country'}
                      iconName={''}
                      onChange={(e) => {
                        handleEmergencyContactInfoChange(
                          'country',
                          e.target.value
                        )
                      }}
                      value={userData?.emergencyContact?.country}
                    />
                  </div>
                </div>
                <div className="w-[48%]">
                  <UITextInput
                    placeholder={'Postcode'}
                    label={'Postcode'}
                    iconName={''}
                    onChange={(e) => {
                      handleEmergencyContactInfoChange(
                        'postCode',
                        e.target.value
                      )
                    }}
                    value={userData?.emergencyContact?.postCode}
                  />
                </div>
              </div>
            </AccordionItem>
          </Accordion>
        </div>

        {/* Second column */}
        <div className="w-4/12">
          <Accordion defaultActiveIndex={0}>
            <AccordionItem
              onClick={() => console.log('Accordion')}
              title={'Scorecard'}
              isActive={true}
              AccordionItemStyle={{
                backgroundColor: 'rgba(230, 240, 243, 1)',
              }}
              AccordiontitleStyle={
                'text-sm text-bluishGreen flex-1 font-semibold'
              }
              AccordionItemStyleContainer={{
                backgroundColor: 'rgba(242, 247, 249, 1)',
              }}
              icon={'IconBarChartSquare'}
            >
              <div className="bg-gray1 flex items-center flex-col justify-center gap-4 my-8">
                <div className="w-[160px] h-[160px]">
                  <CircularProgressbar
                    strokeWidth={5}
                    value={
                      calculateNonNullPercentage([
                        userData?.basicInformation?.profileImage,
                        userData?.basicInformation?.firstName,
                        userData?.basicInformation?.lastName,
                        userData?.basicInformation?.dateOfBirth,
                        userData?.basicInformation?.gender,
                        userData?.basicInformation?.ethnicity,
                        userData?.basicInformation?.disability,
                        userData?.contactInformation?.businessContactNumber,
                        userData?.basicInformation?.nationality,
                        // userData?.contactInformation?.extensionNumber,
                        userData?.contactInformation?.personalContactNumber,
                        userData?.contactInformation?.businessEmail,
                        userData?.address?.addressLineOne,
                        // userData?.address?.addressLineTwo,
                        userData?.address?.town,
                        userData?.address?.country,
                        userData?.address?.postCode,
                        userData?.emergencyContact?.firstName,
                        userData?.emergencyContact?.lastName,
                        userData?.emergencyContact?.contactNumber,
                        userData?.emergencyContact?.relationship,
                        userData?.emergencyContact?.addressLineOne,
                        // userData?.emergencyContact?.addressLineTwo,
                        userData?.emergencyContact?.town,
                        userData?.emergencyContact?.country,
                        userData?.emergencyContact?.postCode,
                      ]).percentage
                    }
                    text={`${
                      calculateNonNullPercentage([
                        userData?.basicInformation?.profileImage,
                        userData?.basicInformation?.firstName,
                        userData?.basicInformation?.lastName,
                        userData?.basicInformation?.dateOfBirth,
                        userData?.basicInformation?.gender,
                        userData?.basicInformation?.ethnicity,
                        userData?.basicInformation?.disability,
                        userData?.contactInformation?.businessContactNumber,
                        userData?.basicInformation?.nationality,
                        // userData?.contactInformation?.extensionNumber,
                        userData?.contactInformation?.personalContactNumber,
                        userData?.contactInformation?.businessEmail,
                        userData?.address?.addressLineOne,
                        // userData?.address?.addressLineTwo,
                        userData?.address?.town,
                        userData?.address?.country,
                        userData?.address?.postCode,
                        userData?.emergencyContact?.firstName,
                        userData?.emergencyContact?.lastName,
                        userData?.emergencyContact?.contactNumber,
                        userData?.emergencyContact?.relationship,
                        userData?.emergencyContact?.addressLineOne,
                        // userData?.emergencyContact?.addressLineTwo,
                        userData?.emergencyContact?.town,
                        userData?.emergencyContact?.country,
                        userData?.emergencyContact?.postCode,
                      ]).percentage
                    }%`}
                    styles={{
                      root: {},
                      path: {
                        stroke: calculateNonNullPercentage([
                          userData?.basicInformation?.profileImage,
                          userData?.basicInformation?.firstName,
                          userData?.basicInformation?.lastName,
                          userData?.basicInformation?.dateOfBirth,
                          userData?.basicInformation?.gender,
                          userData?.basicInformation?.ethnicity,
                          userData?.basicInformation?.disability,
                          userData?.contactInformation?.businessContactNumber,
                          userData?.basicInformation?.nationality,
                          // userData?.contactInformation?.extensionNumber,
                          userData?.contactInformation?.personalContactNumber,
                          userData?.contactInformation?.businessEmail,
                          userData?.address?.addressLineOne,
                          // userData?.address?.addressLineTwo,
                          userData?.address?.town,
                          userData?.address?.country,
                          userData?.address?.postCode,
                          userData?.emergencyContact?.firstName,
                          userData?.emergencyContact?.lastName,
                          userData?.emergencyContact?.contactNumber,
                          userData?.emergencyContact?.relationship,
                          userData?.emergencyContact?.addressLineOne,
                          // userData?.emergencyContact?.addressLineTwo,
                          userData?.emergencyContact?.town,
                          userData?.emergencyContact?.country,
                          userData?.emergencyContact?.postCode,
                        ]).color,
                        transition: 'stroke-dashoffset 0.5s ease 0s',
                      },
                      text: {
                        fill: '#013546',
                        fontSize: '24px',
                        fontWeight: 700,
                        lineHeight: 40,
                      },
                    }}
                  />
                </div>
                <div className="items-center justify-center flex">
                  <p className="text-sm font-semibold  w-[80%]  text-text2 leading-6 text-center">
                    {calculateNonNullPercentage([
                      userData?.basicInformation?.profileImage,
                      userData?.basicInformation?.firstName,
                      userData?.basicInformation?.lastName,
                      userData?.basicInformation?.dateOfBirth,
                      userData?.basicInformation?.gender,
                      userData?.basicInformation?.ethnicity,
                      userData?.basicInformation?.disability,
                      userData?.contactInformation?.businessContactNumber,
                      userData?.basicInformation?.nationality,
                      // userData?.contactInformation?.extensionNumber,
                      userData?.contactInformation?.personalContactNumber,
                      userData?.contactInformation?.businessEmail,
                      userData?.address?.addressLineOne,
                      // userData?.address?.addressLineTwo,
                      userData?.address?.town,
                      userData?.address?.country,
                      userData?.address?.postCode,
                      userData?.emergencyContact?.firstName,
                      userData?.emergencyContact?.lastName,
                      userData?.emergencyContact?.contactNumber,
                      userData?.emergencyContact?.relationship,
                      userData?.emergencyContact?.addressLineOne,
                      // userData?.emergencyContact?.addressLineTwo,
                      userData?.emergencyContact?.town,
                      userData?.emergencyContact?.country,
                      userData?.emergencyContact?.postCode,
                    ]).percentage == 100
                      ? 'Well done you reached 100%'
                      : calculateNonNullPercentage([
                            userData?.basicInformation?.profileImage,
                            userData?.basicInformation?.firstName,
                            userData?.basicInformation?.lastName,
                            userData?.basicInformation?.dateOfBirth,
                            userData?.basicInformation?.gender,
                            userData?.basicInformation?.ethnicity,
                            userData?.basicInformation?.disability,
                            userData?.contactInformation?.businessContactNumber,
                            userData?.basicInformation?.nationality,
                            // userData?.contactInformation?.extensionNumber,
                            userData?.contactInformation?.personalContactNumber,
                            userData?.contactInformation?.businessEmail,
                            userData?.address?.addressLineOne,
                            // userData?.address?.addressLineTwo,
                            userData?.address?.town,
                            userData?.address?.country,
                            userData?.address?.postCode,
                            userData?.emergencyContact?.firstName,
                            userData?.emergencyContact?.lastName,
                            userData?.emergencyContact?.contactNumber,
                            userData?.emergencyContact?.relationship,
                            userData?.emergencyContact?.addressLineOne,
                            // userData?.emergencyContact?.addressLineTwo,
                            userData?.emergencyContact?.town,
                            userData?.emergencyContact?.country,
                            userData?.emergencyContact?.postCode,
                          ]).percentage == 0
                        ? 'Make a start to improve your score'
                        : ' Great start! But there is still room for improvement'}
                  </p>
                </div>
                <Accordion defaultActiveIndex={0}>
                  <AccordionItem
                    onClick={() => console.log('Accordion')}
                    title={' Your score is broken down as follows:'}
                    isActive={true}
                    AccordionItemStyle={{ backgroundColor: '#FFFFFF' }}
                    AccordiontitleStyle={
                      'text-xs font-semibold text-text4 leading-5 flex-1'
                    }
                    AccordionItemStyleContainer={{
                      backgroundColor: '#FFFFFF',
                    }}
                  >
                    <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                      <div className="mt-3">
                        <UIStaightlineProressBar
                          percentage={
                            calculateNonNullPercentage([
                              userData?.basicInformation?.profileImage,
                              userData?.basicInformation?.firstName,
                              userData?.basicInformation?.lastName,
                              userData?.basicInformation?.dateOfBirth,
                              userData?.basicInformation?.gender,
                              userData?.basicInformation?.ethnicity,
                              userData?.basicInformation?.disability,
                            ]).percentage
                          }
                          label={'Basic Information'}
                          stroke={
                            calculateNonNullPercentage([
                              userData?.basicInformation?.profileImage,
                              userData?.basicInformation?.firstName,
                              userData?.basicInformation?.lastName,
                              userData?.basicInformation?.dateOfBirth,
                              userData?.basicInformation?.gender,
                              userData?.basicInformation?.ethnicity,
                              userData?.basicInformation?.disability,
                            ]).color
                          }
                          strokeWidth={1.5}
                        />
                      </div>

                      <div className="mt-3">
                        <UIStaightlineProressBar
                          percentage={
                            calculateNonNullPercentage([
                              userData?.contactInformation
                                ?.businessContactNumber,
                              // userData?.contactInformation?.extensionNumber,
                              userData?.contactInformation
                                ?.personalContactNumber,
                              userData?.contactInformation?.businessEmail,
                            ]).percentage
                          }
                          label={'Contact Information'}
                          stroke={
                            calculateNonNullPercentage([
                              userData?.contactInformation
                                ?.businessContactNumber,
                              // userData?.contactInformation?.extensionNumber,
                              userData?.contactInformation
                                ?.personalContactNumber,
                              userData?.contactInformation?.businessEmail,
                            ]).color
                          }
                          strokeWidth={1.5}
                        />
                      </div>
                      <div className="mt-3">
                        <UIStaightlineProressBar
                          percentage={
                            calculateNonNullPercentage([
                              userData?.address?.addressLineOne,
                              // userData?.address?.addressLineTwo,
                              userData?.address?.town,
                              userData?.address?.country,
                              userData?.address?.postCode,
                            ]).percentage
                          }
                          label={'Address'}
                          stroke={
                            calculateNonNullPercentage([
                              userData?.address?.addressLineOne,
                              // userData?.address?.addressLineTwo,
                              userData?.address?.town,
                              userData?.address?.country,
                              userData?.address?.postCode,
                            ]).color
                          }
                          strokeWidth={1.5}
                        />
                      </div>
                      <div className="mt-3">
                        <UIStaightlineProressBar
                          percentage={
                            calculateNonNullPercentage([
                              userData?.emergencyContact?.firstName,
                              userData?.emergencyContact?.lastName,
                              userData?.emergencyContact?.contactNumber,
                              userData?.emergencyContact?.relationship,
                              userData?.emergencyContact?.addressLineOne,
                              // userData?.emergencyContact?.addressLineTwo,
                              userData?.emergencyContact?.town,
                              userData?.emergencyContact?.country,
                              userData?.emergencyContact?.postCode,
                            ]).percentage
                          }
                          label={'Emergency Contact'}
                          stroke={
                            calculateNonNullPercentage([
                              userData?.emergencyContact?.firstName,
                              userData?.emergencyContact?.lastName,
                              userData?.emergencyContact?.contactNumber,
                              userData?.emergencyContact?.relationship,
                              userData?.emergencyContact?.addressLineOne,
                              // userData?.emergencyContact?.addressLineTwo,
                              userData?.emergencyContact?.town,
                              userData?.emergencyContact?.country,
                              userData?.emergencyContact?.postCode,
                            ]).color
                          }
                          strokeWidth={1.5}
                        />
                      </div>
                    </div>
                  </AccordionItem>
                </Accordion>
              </div>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
      <div className="bg-gray3 w-full h-[1px] my-3"></div>
      <div className="w-[33%] mt-6">
        <UIButton
          onClick={() => {
            if (userData) {
              updateProfileData(userData)
            } else {
              // Handle the case where userData is undefined, maybe show a message or perform some other action
              console.error('userData is undefined')
            }
          }}
          loading={isUpdateLoading}
          label="Update"
        />
        <Modal
          customStyle={{ width: '480px', borderRadius: 16 }}
          isOpen={isOpenAlert}
          onClose={() => {
            setIsOpenAlert(false)
          }}
        >
          <div
            className={
              'max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
            }
          >
            <div
              onClick={() => {
                setIsOpenAlert(false)
              }}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconAlertTriangle'}
                stroke={'#FF6666'}
                strokeWidth={1}
                height={52}
                width={52}
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-[18px] font-bold'}>
                Save changes?
              </h1>
              <p className={'text-[14px] text-text1 font-normal'}>
                Do you want to save changes before moving on?{' '}
              </p>
            </div>

            <button
              onClick={() => {
                if (userData) {
                  updateProfileData(userData)
                } else {
                  // Handle the case where userData is undefined, maybe show a message or perform some other action
                  console.error('userData is undefined')
                }
                setIsOpenAlert(false)
              }}
              className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
            >
              Save changes
            </button>
            <button
              onClick={() => {
                setIsOpenAlert(false)
              }}
              className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
            >
              {`Don't save`}
            </button>
          </div>
        </Modal>
      </div>
    </div>
  )
}

export default ProfileInformation
